$.fn.modal.Constructor.prototype.enforceFocus = function() {};

$(function() {
    const dropdownList = $('.nav-item>a[href="/theatres"]').parent().find(".dropdown");
    const dropdownItems = dropdownList.children()
    let heightList = 0;
    if(dropdownItems.length > 8) {
        const listGap = parseInt(dropdownList.css("row-gap"));
        dropdownItems.map((index, item)=>{
            if(index < 8) {
                heightList += $(item).outerHeight() + listGap;
            }
        })
        const listPadding = parseInt(dropdownList.css("padding").split(" ")[0]);
        heightList += listPadding;
        dropdownList.css("overflow-y", "scroll").css("height", heightList)
    }
})

$(".page").on("click", ".add-to-fav", function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    $.ajax({
        url: "/favorite/add",
        method: "post",
        data: {filmId: $target.data("film-id")},
        beforeSend: function () {
            $target.removeClass("add-to-fav").addClass("remove-from-fav");
        }
    })
        .done(function (response) {
            if (response) {
                $target.data("fav-id", response);
            } else {
                $target.addClass("add-to-fav").removeClass("remove-from-fav");
            }
        })
        .fail(function () {
            console.log("error on adding film to favorite");
        });
});

$(".page").on("click", ".remove-from-fav", function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    $.ajax({
        url: "/favorite/remove",
        method: "post",
        data: {favId: $target.data("fav-id")},
        beforeSend: function () {
            $target.removeClass("remove-from-fav").addClass("add-to-fav");
        }
    })
        .done(function (response) {
            if (!response) {
                $target.addClass("remove-from-fav").removeClass("add-to-fav");
            } else {
                $target.removeData("data-fav-id");
            }
        })
        .fail(function () {
            console.log("error on adding film to favorite");
        });
});

$(document).on("click", ".city-tooltip__close", function (e) {
    e.preventDefault();
    $.ajax({
        url: "/site/stop-geo",
        method: "post"
    })
        .done(function (response) {
            $(".city-tooltip__close")
                .parents(".city-tooltip")
                .fadeOut();
        })
        .fail(function () {
            console.log("error on adding film to favorite");
        });
});

$(document).on("click", ".reset-cookies", function () {
    $.ajax({
        url: "/site/reset-cookies",
        method: "post"
    })
        .done(function (response) {
            // console.log('success');
            // window.location.reload();
        })
        .fail(function () {
            console.log("error on resetting cookies");
        });
});

$(document).on("click", ".orders-history button", function (e) {
    var $target = $(e.currentTarget);
    $($target).next().addClass('hide');
    $.ajax({
        url: "/user/cabinet/cancel-order",
        method: "post",
        data: {ticketReservationId: $target.data('ticket-order'), barReservationId: $target.data('bar-order')}
    })
    .done(function (response) {
        $($target).next().removeClass().addClass(response.success ? 'text-success' : 'text-danger').text(response.message);
        if (response.success) {
            $target.parents('.orders-history__item').find('.orders-history__number-state').html('<span class="number-state__bullet state-bullet-violet"></span> Возвращён');
            $target.hide();
        }
    })
    .fail(function () {
        console.log("error on order cancelling");
    });
});

$(document).on("click", '[data-adult-check="true"]', function (e) {
    e.preventDefault();

    var targetUrl = $(e.currentTarget).attr("href");
    $("#adultModal").modal("show");
    $("#adultModal")
        .on("click", ".redirect-forward", function (e) {
            e.preventDefault();
            $.ajax({
                method: "get",
                url: "/site/set-adult"
            }).done(function (response) {
                if (response) {
                    window.location.href = targetUrl;
                }
            });
        })
        .on("click", ".redirect-back", function (e) {
            e.preventDefault();
            $("#adultModal").modal("hide");
        });
});

checkAdultOnLoad();

$("#cityModal")
    .off("show.bs.modal")
    .on("show.bs.modal", function () {
        $(".suggest-city__select").select2({width: "100%", theme: "krajee"});
        $("#suggest-city__form").on("click", ".submit-check", function (e) {
            e.preventDefault();
            var value = $(".suggest-city__select").val();
            if (value) {
                window.location.href =
                    /* $('.suggest-city__select').val() === $('#suggest-city__form').data('default') ? '/' :*/ "/set-city/" +
                    value;
            }
        });

        $.ajax({
            url: "/location/get-force",
            method: "get"
        })
            .done(function (response) {
                console.log(response);
                if (response.city.status && response.city.data) {
                    var data = response.city.data;
                    if (data) {
                        renderCityTooltips(data, response.defaultCity);
                    }
                }
            })
            .fail(function () {
                console.log("network error");
            });
        var renderCityTooltips = function (data, defaultCityId) {
            var alias =
                /*defaultCityId === data.city.id ? '/' :*/ "/set-city/" +
                data.city.alias;

            $(".suggest .suggest__value")
                .attr({
                    href: alias
                })
                .find(".text-border-gradient__text")
                .text(data.city.name);
        };
    });

function checkAdultOnLoad() {
    var checkAdult = $('[data-adult-load="true"]').length > 0;
    if (checkAdult) {
        $("#adultModal").modal("show");
        $("#adultModal")
            .on("click", ".redirect-forward", function (e) {
                e.preventDefault();
                $.ajax({
                    method: "get",
                    url: "/site/set-adult"
                }).done(function (response) {
                    if (response) {
                        $("#adultModal").modal("hide");
                    }
                });
            })
            .on("click", ".redirect-back", function (e) {
                e.preventDefault();
                history.go(-1);
            });
    }
}

$("input[name='signin-login']").on("change", function (e) {
    var targetId = $(this).data("target-id");
    var targets$ = $(this)
        .closest("#blockSigninLogin")
        .find("[data-target]");
    var target$ = targets$.filter("[data-target='" + targetId + "']");
    var input$ = target$.find("input:text");

    target$.removeClass("hide");
    input$.removeAttr("disabled");
    targets$
        .not(target$)
        .addClass("hide")
        .find("input:text")
        .attr("disabled", "disabled");
});

var renderData = function (data) {
    var lists = data.result;
    var currentData = data.currentData;

    renderList(lists["districtList"], currentData.districtId, "district");
    renderList(lists["regionList"], currentData.regionId, "region");
    renderList(
        lists["cityList"],
        currentData.cityId,
        "city",
        currentData.defaultCityId
    );
    $("#suggest-city__form").data("default", currentData.defaultCityAlias);
};

var renderList = function (items, currentValue, listName, defaultValue = null) {
    var $list = $(`.city-picker__list[data-list=${listName}]`);
    $list.html("");
    Object.values(items).forEach(entry => {
        var isActiveClass =
            entry.id === currentValue ? " text-border-gradient_active" : "";

        var li = $("<li>").appendTo($list);
        var a = $("<a>", {
            class: "text-border-gradient" + isActiveClass,
            href:
                listName === "city"
                    ? /*defaultValue === entry.id ? '/' : */ "/set-city/" + entry.alias
                    : "",
            data: {
                id: entry.id
            }
        }).appendTo(li);
        $("<span>", {
            text: entry.name,
            class: "text-border-gradient__text"
        }).appendTo(a);
    });
};

$(".toggle-password-input").on("click", function (e) {
    var $target = $(e.currentTarget),
        $input = $target.parent().find("input");
    var inputType = $input.attr("type"),
        newType = inputType === "password" ? "text" : "password";

    $input.attr("type", newType);
});

function initPlayer() {
    $(".jwplayer-trailer").each((index, item) => {
        let $item = $(item),
            itemId = $(item).attr("id"),
            itemHeight = $(item).data("height");

        if (!itemId) {
            itemId = "jwplayer" + index;
            $item.attr("id", itemId);
        }
        jwplayer(itemId).setup({
            width: "100%",
            height: itemHeight ? itemHeight : 320,
            file: $item.data("video"),
            image: $item.data("poster")
        });
    });
}

initPlayer();

$("#player-init").on("pjax:success", function () {
    initPlayer();
});

initAuth();
initRegistration();
initMapCard();
initProfile();

function initProfile() {
    var form$ = $("#formProfile");
    var countdownWrapper$ = $(".wrapperCountdown", form$);
    var countdown$ = $("#sms-countdown", countdownWrapper$);
    var ttl = countdownWrapper$.data("ttl") || 0;

    form$.find("div.sms-resend").hide();

    $("input[name='ProfileForm[gender]']:radio", form$).on("change", function (e) {
        var val = $("input[name='ProfileForm[gender]']:radio:checked", form$).val();
        form$.find("input[name='ProfileForm[gender]'][type=hidden]").val(val);
    });

    $("input[name='ProfileForm[code]']", form$).on("keydown", function (e) {
        if (e.which === 13) {
            e.preventDefault();
            form$.find('button[data-action="form-sms"]').trigger("click");
        }
    });

    var addField = function (formData, name, filter) {
        var key = "ProfileForm[" + name + "]";
        var field$ = form$.find("[name='ProfileForm[" + name + "]']");
        field$ = filter ? field$.filter(filter) : field$;
        formData.set(key, field$.val());
        return field$.val();
    };

    $("button[data-action='form-sms']", form$).on("click", function (e) {
        var _this = $(this);
        e.preventDefault();

        var onDone = function (response) {
            if (response.success === true) {
                location.reload();
            } else {
                displayResponseErrors(response, "ProfileForm", form$);
            }
        };
        var data = new FormData();
        addField(data, "username");
        addField(data, "name");
        addField(data, "email");
        addField(data, "phone");
        addField(data, "gender");
        addField(data, "birthday");
        addField(data, "image");
        addField(data, "code");
        data.set("_csrf", form$.find("[name='_csrf']").val());

        var url = form$.attr("action");
        sendAjaxRequest(_this, form$, url, "post", data, onDone);
    });

    $("button[data-action='form-send']", form$).on("click", function (e) {
        var _this = $(this);
        e.preventDefault();

        countdownWrapper$.hide();
        form$.find("div.sms-resend").hide();

        var data = new FormData();
        addField(data, "username");
        addField(data, "name");
        addField(data, "email");
        addField(data, "phone");
        addField(data, "gender");
        addField(data, "birthday");
        addField(data, "image");
        data.set("_csrf", form$.find("[name='_csrf']").val());

        var onDone = function (response) {
            if (response.success === true) {
                var url = form$.attr("action");
                var onDone = function (response) {
                    if (response.success === true) {
                        location.reload();
                    } else {
                        displayResponseErrors(response, "ProfileForm", form$);
                    }
                };
                sendAjaxRequest(_this, form$, url, "post", data, onDone);
            } else if (response.smscode) {
                form$
                    .find(".sms-code")
                    .closest(".form-group")
                    .find("label")
                    .html(response.message);
                form$.find(".field-profileform-code").show();
                form$
                    .find("button[data-action='form-sms']")
                    .css({display: "flex"})
                    .show();
                form$.find("button[data-action='form-send']").hide();
                countdownWrapper$.show();
                countdown$.countdown($.now() + ttl * 60 * 1000);
                countdown$.on("finish.countdown", function (e) {
                    onCountDownFinished(form$, "button[data-action='form-send']");
                });
                countdownWrapper$.insertBefore("#profileform-code");
            } else {
                displayResponseErrors(response, "ProfileForm", form$);
            }
        };

        var url = "/user/cabinet/validate-profile";
        sendAjaxRequest(_this, form$, url, "post", data, onDone);
    });
}

function onCountDownFinished(_form$, sendSmsSelector) {
    //debugger;
    _form$.find("div.sms-resend").fadeIn();
    _form$
        .find("div.sms-resend .button_resend")
        .off("click")
        .on("click", function () {
            _form$.find(sendSmsSelector).trigger("click");
        });
}

function sendAjaxRequest(sender$, form$, $url, $method, $data, onDone) {
    $.ajax({
        url: $url,
        method: $method || "post",
        cache: false,
        async: true,
        data: $data,
        processData: false,
        contentType: false,
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        beforeSend: function () {
            form$.find("input").attr("disabled", "disabled");
            form$.find("button").attr("disabled", "disabled");
            form$.find(".help-block-error").html("");
            if (sender$) {
                sender$.find(".loading").remove();
                sender$.append("<div class='loading'></div>");
            }
        }
    })
        .done(function (response) {
            form$.find("input").removeAttr("disabled");
            form$.find("button").removeAttr("disabled");
            if (sender$) {
                sender$.find(".loading").remove();
            }
            console.log(response);
            if (onDone) {
                onDone(response);
            }
        })
        .fail(function (xhr) {
            console.log("network error");
            form$.find("input").removeAttr("disabled");
            form$.find("button").removeAttr("disabled");
            if (sender$) {
                sender$.find(".loading").remove();
            }
            form$
                .find(".help-block-error:visible")
                .last()
                .html("Произошла непредвиденная ошибка");
        });
}

function initMapCard() {
    $("#formMapCard button[type='submit']").on("click", function (e) {
        var _this = $(this);
        var form$ = _this.closest("form");
        var attrName = "CardForm[oldCard]";
        e.preventDefault();

        var onDone = function (response) {
            if (response.success === true) {
                location.reload();
            } else {
                displayResponseErrors(response, "CardForm", form$);
            }
        };

        var data = new FormData();
        data.set(attrName, form$.find("[name='" + attrName + "']").val());
        data.set("_csrf", form$.find("[name='_csrf']").val());

        sendAjaxRequest(_this, form$, form$.attr("action"), "post", data, onDone);
    });
}

function initAuth() {
    $("#authModal")
        .off("show.bs.modal")
        .on("show.bs.modal", function () {
            var authLoginSelector = "[data-auth]:not([disabled]):visible:eq(0)";
            var authPasswordSelector = "#authform-password";
            var form$ = $("#authModal").find("form");
            var $errorField = $(authPasswordSelector)
                .parents(".form-group")
                .find(".help-block-error");

            $(authLoginSelector + ", " + authPasswordSelector).on(
                "input",
                function () {
                    $errorField.html("");
                }
            );

            $('button[type="submit"]', form$)
                .off("click")
                .on("click", function (e) {
                    e.preventDefault();
                    var username = $(authLoginSelector).val();
                    var password = $(authPasswordSelector).val();
                    var rememberme = $("#authform-rememberme").val();
                    signIn(username, password, rememberme, form$, $errorField);
                });
        });
}

function initRegistration() {
    $("#regModal input[name='RegistrationForm[gender]']:radio").on("change", function (e) {
        var form$ = $(this).closest("form");
        var val = $("input[name='RegistrationForm[gender]']:radio:checked", form$).val();
        form$.find("input[name='RegistrationForm[gender]'][type=hidden]").val(val);
    });

    $("#regModal input[name='RegistrationForm[code]']").on("keydown", function (e) {
        if (e.which === 13) {
            e.preventDefault();
            var form$ = $(this).closest("form");
            form$.find('button[type="button"].button_complete').trigger("click");
        }
    });

    $("#regModal")
        .off("show.bs.modal")
        .on("show.bs.modal", function () {
            var form$ = $("#regModal").find("form");
            var countdownWrapper$ = $(".wrapperCountdown", form$);
            var countdown$ = $("#sms-countdown", countdownWrapper$);
            var ttl = countdownWrapper$.data("ttl") || 0;

            countdownWrapper$.hide();
            form$.find(".help-block-error").html("");
            form$.find(".loading").remove();
            form$.find(".field-registrationform-code input").val();
            form$.find(".field-registrationform-code").hide();
            form$.find(".button_complete").hide();
            form$.find("div.sms-resend").hide();
            form$
                .find(".button_reg")
                .css({display: "flex"})
                .show();

            var addField = function (formData, name, filter) {
                var key = "RegistrationForm[" + name + "]";
                var field$ = form$.find("[name='RegistrationForm[" + name + "]']");
                field$ = filter ? field$.filter(filter) : field$;
                formData.set(key, field$.val());
                return field$.val();
            };

            $('button[type="button"].button_complete', form$)
                .off("click")
                .on("click", function (e) {
                    var _this = $(this);
                    e.preventDefault();

                    var data = new FormData();
                    var url = "/complete-registration";
                    addField(data, "name");
                    var login = addField(data, "email");
                    addField(data, "phone");
                    addField(data, "gender");
                    addField(data, "birthday");
                    var password = addField(data, "password");
                    addField(data, "passwordRepeat");
                    addField(data, "code");
                    addField(data, "reCaptcha");
                    data.set("_csrf", form$.find("[name='_csrf']").val());

                    var onDone = function (response) {
                        if (response.success === true) {
                            signIn(
                                login,
                                password,
                                true,
                                form$,
                                form$.find(".help-block-error:visible").last()
                            );
                        } else {
                            if (response.error) {
                                form$
                                    .find("[name='RegistrationForm[code]']")
                                    .closest("div.form-group")
                                    .find(".help-block-error")
                                    .html(response.error);
                            }
                        }
                    };

                    sendAjaxRequest(_this, form$, url, "post", data, onDone);
                });

            $('button[type="submit"]', form$)
                .off("click")
                .on("click", function (e) {
                    var _this = $(this);
                    e.preventDefault();

                    countdownWrapper$.hide();
                    form$.find("div.sms-resend").hide();

                    var data = new FormData();
                    addField(data, "name");
                    var login = addField(data, "email");
                    addField(data, "phone");
                    addField(data, "gender");
                    addField(data, "birthday");
                    var password = addField(data, "password");
                    addField(data, "passwordRepeat");
                    addField(data, "reCaptcha");
                    data.set("_csrf", form$.find("[name='_csrf']").val());

                    var onDone = function (response) {
                        if (response.success === true) {
                            form$
                                .find(".sms-code")
                                .closest(".form-group")
                                .find("label[for='registrationform-code']")
                                .html(response.message);
                            form$.find(".field-registrationform-code").show();
                            form$
                                .find(".button_complete")
                                .css({display: "flex"})
                                .show();
                            form$.find(".button_reg").hide();
                            $("#allowReg").hide();

                            countdownWrapper$.show();
                            countdown$.countdown($.now() + ttl * 60 * 1000);
                            countdown$.on("finish.countdown", function (e) {
                                onCountDownFinished(form$, "button.button_reg");
                            });
                            countdownWrapper$.insertBefore("#registrationform-code");
                        } else {
                            displayResponseErrors(response, "RegistrationForm", form$);
                        }
                        if (window.grecaptcha !== undefined && window.recaptchaInit !== undefined)
                            recaptchaInit();
                    };

                    sendAjaxRequest(
                        _this,
                        form$,
                        form$.attr("action"),
                        "post",
                        data,
                        onDone
                    );
                });
        });
}

function displayResponseErrors(response, formName, form$) {
    if (response.errors) {
        $.each(response.errors, function (ind, val) {
            var errorMessage = val[0];
            var control$ = form$.find("[name='" + formName + "[" + ind + "]']");
            if (control$.length) {
                control$
                    .closest("div.form-group")
                    .find(".help-block-error")
                    .html(errorMessage);
            }
        });
    } else if (response.error) {
        form$
            .find(".help-block-error:visible")
            .last()
            .html(response.error);
    } else {
        form$
            .find(".help-block-error:visible")
            .last()
            .html("Произошла непредвиденная ошибка");
    }
}

function signIn(login, password, rememberme, form$, $errorField) {
    var redirectUrl = form$.data("redirect-url");
    var authUrl =
        form$.data("auth-host") + "/auth/async?redirect-url=" + redirectUrl;
    var data = new FormData();
    data.set("AuthForm[username]", login);
    data.set("AuthForm[password]", password);
    data.set("AuthForm[rememberMe]", rememberme ? 1 : 0);

    var localizeMessage = function (message) {
        var result = "Ошибка";
        if (message) {
            if (message === "User not active") {
                result = "Учетная запись не активирована";
            } else {
                var expandedMessage = message.split(" ");
                if (expandedMessage[0] === "Invalid") {
                    result = "Неверный пароль";
                }
                if (expandedMessage[0] === "No") {
                    result = "Пользователь не найден";
                }
            }
        }
        return result;
    };

    if (login && password) {
        var onDone = function (response) {
            if (response.success === true) {
                if (rememberme) {
                    $.cookie('i', response.token, {expires: 30, path: '/'});
                } else {
                    $.cookie('i', response.token, {path: '/'});
                }
                window.location.href = redirectUrl;
            } else {
                if (response.errors) {
                    var errorMessage = localizeMessage(response.errors[0]);
                    if ($errorField) {
                        $errorField.html(errorMessage);
                    }
                }
            }
        };

        sendAjaxRequest(null, form$, authUrl, "post", data, onDone);
    } else {
        if ($errorField) {
            $errorField.html("Необходимо заполнить логин и пароль");
        }
    }
}

$(document).on("click", ".user-logout", function () {
    $.cookie('i', null, {path: '/'});
});

$('.carousel-stacked').on('init', function (e, slick) {
    let $target = $(e.currentTarget);

    $target.removeClass('carousel-stacked__rendering');
}).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    focusOnSelect: true,
    lazyLoad: 'ondemand',
    // centerMode: true,
    // centerPadding: '0px',
    prevArrow: "<a class='slick-arrow_dots slick-arrow_prev glyphicon glyphicon-menu-left'></a>",
    nextArrow: "<a class='slick-arrow_dots slick-arrow_next glyphicon glyphicon-menu-right'></a>",
    appendArrows: $('.carousel-stacked'),
});

function carouselFilmsInit() {
    let slide = 0;

    $('.carousel-films').on('init', function (e, slick) {
        let $target = $(e.currentTarget);
        $target.find('.slick-arrow_prev').appendTo($target.find('.slick-dots'));
        $target.find('.slick-arrow_next').appendTo($target.find('.slick-dots'));
    }).on('afterChange', function (event, slick, currentSlide) {
        if (slide !== currentSlide) {
            var items = $('.carousel-films').find('.slick-slide:not(.slick-active)');
            items.each(function (indx, element) {
                var item = $(element).find('.jwplayer').attr('id');
                jwplayer(item).play(false);
            });
            slide = currentSlide;
        }
    }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        adaptiveHeight: true,
        // centerMode: true,
        // centerPadding: '0px',
        prevArrow: "<li class='slick-arrow_dots slick-arrow_prev glyphicon glyphicon-chevron-left'></li>",
        nextArrow: "<li class='slick-arrow_dots slick-arrow_next glyphicon glyphicon-chevron-right'></li>",
    });
}

carouselFilmsInit();

function hideUnnecessaryItems(container) {
    let $container = $(container);
    let items = $container.children();
    items.slice(1).each((i, item) => {
        let $item = $(item);
        $item.show();
        $item.css("display", 'flex')
        let lastItemRight = $item.offset().left + $item.width()
        let leftForNavbarRight = $('.navbar .navbar-right').offset().left
        if (lastItemRight > leftForNavbarRight) {
            $item.hide();
        }
    });
}

$(window).resize((e) => {
    //locateSubnavMenu();
    locateMainPageWrapper();
    hideUnnecessaryItems($('.navbar .navbar-category'));
    setStillSise();
    messageModalStyles();
});

function locateSubnavMenu() {
    //$(".navbar .navbar-category li .subnav").css("top", `${+$(".navbar").css("height").slice(0, -2)}px`);
}

function locateMainPageWrapper() {
    let navbarHeight = $(".navbar").css("height");
    $(".content-wrapper").css({
        top: navbarHeight,
        minHeight: `calc(100vh - ${navbarHeight}`,
    });
}

//locateSubnavMenu();
locateMainPageWrapper();
hideUnnecessaryItems($('.navbar .navbar-category'));
$('.cookie-notice').find('.close-notice').on('click', function () {
    $.cookie('cookie-notice', '1', {path: '/'});
    $('.cookie-notice').remove();

    return false;
});

function setStillSise() {
    let dropdown = $('.navbar-category li.nav-item .still-dropdown');
    let indent = 5;
    let navbarLength = $('.navbar')[0].offsetWidth;
    let dropdownWidth = 100 * (navbarLength) / window.innerWidth - 2 * indent;
    let dropdownLeft = 100 * $('.navbar').offset().left / window.innerWidth + indent;
    dropdown.css('width', `${dropdownWidth}vw`);
    let navbarHeight = $(".navbar").css("height");
    dropdown.css('left', `${dropdownLeft}vw`);
    dropdown.css('top', navbarHeight);
    if (dropdownWidth < 75) {
        dropdown.css('grid-template-columns', '1fr 1fr');
    }
}

setStillSise();

$(".still").click(function (e) {
    $(this).toggleClass("active");
}).hover(function (e) {
    e.preventDefault();
    if (!$(this).hasClass("active")) {
        $(this).addClass("active");
    }
}, function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
    }
})

function messageModalStyles() {
    let modal = $("#messageModal");
    let imageContainer = modal.find(".message-modal__image");
    let messageContainer = modal.find(".message-modal__container");
    let title = modal.find(".message-modal__title");
    let btns = modal.find(".message-modal__buttons");
    let containerHeight = messageContainer.height();
    let gaps = messageContainer.css("gap") ? +messageContainer.css("gap").slice(0, -2) * 2 : 0;
    let imageHeight = (containerHeight - title.height() - btns.height() - gaps) / containerHeight * 100;
    imageContainer.css("max-height", `${imageHeight}%`)

    messageModalTextStyles();
}

$(document).ready(function(){
    messageModalStyles();
});

function messageModalTextStyles(){
    let modal = $("#messageModal");
    let container = modal.find(".message-modal__container");
    let title = modal.find(".message-modal__title");
    let btns = modal.find(".message-modal__buttons");
    let btnTop = btns.length ? btns.offset().top : 0;
    let btnBottom = btns.height() + btnTop;
    let containerInnerBottom = container.length ? container.offset().top + container.innerHeight() : 0;
    let titleFZ = title.css("font-size") ? +title.css("font-size").slice(0, -2) : 0;
    let modalContent = modal.find(".modal-content");
    let modalBottom = modalContent.length ? modalContent.offset().top + modalContent.height() : 0;
    let modalMaxBottom = window.innerHeight * 0.75 + (modalContent.length ? modalContent.offset().top : 0);

    let calculateDiff = function() {
        return btnBottom - containerInnerBottom;
    }

    let onChangeSize = function () {
        title.css("font-size", `${titleFZ}px`);
        btnTop = btns.length ? btns.offset().top : 0;
        btnBottom = btns.height() + btnTop;
        containerInnerBottom = container.length ? container.offset().top + container.innerHeight() : 0;
        modalBottom = modalContent.length ? modalContent.offset().top + modalContent.height() : 0;
    }

    if (window.innerWidth > 1200) {
        while(titleFZ < 35) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth > 991 && window.innerWidth < 1200) {
        while(titleFZ < 32) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth >= 768 && window.innerWidth <= 991) {
        while(titleFZ < 30) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth <= 767) {
        while(titleFZ < 25) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth <= 480) {
        while(titleFZ < 20) {
            titleFZ++;
            onChangeSize();
        }
    }

    while(calculateDiff() > 0 && modalBottom >= modalMaxBottom && titleFZ > 10) {
        titleFZ--;
        onChangeSize();
    }
}


// WEBPACK FOOTER //
// ./frontend/web/js/app.js